import { useContext, useEffect, useState } from "react";
import { AuthContext } from "contexts/Auth";

export const useUserSubscription = () => {
	const [isUserSubscribed, setIsUserSubscribed] = useState(false);
	const { jwtContent } = useContext(AuthContext);

	useEffect(() => {
		if (!jwtContent) return;
		setIsUserSubscribed(Boolean(jwtContent.subscriptionPlan));
	}, [jwtContent]);

	return { isUserSubscribed };
};
